import Request from "@/common/net/request.js";
const request = new Request();
// 运费审核列表
export function getFeeConfirmPage(data) {
  return request.send({
    url: `/pmy/freight/order/pricing/fee/confirm/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 待核价订单列表
export function getFeeWithoutPage(data) {
  return request.send({
    url: `/pmy/freight/order/pricing/fee/without`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 核价订单设置价格
export function feeSetFreight(data) {
  return request.send({
    url: `/pmy/freight/order/pricing/fee/set`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 运费审核--提交审核
export function feeConfirm(data) {
  return request.send({
    url: `/pmy/freight/order/pricing/fee/confirm`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 三方订单已完成
export function completeLxOrder(data) {
  return request.send({
    url: `/pmy/freight/order/freight/lx/complete`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 查询待办数量
export function getPricingBacklog(data) {
  return request.send({
    url: `/pmy/freight/order/pricing/backlog`,
    method: "get"
  });
}
